import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="mt-24 pt-8 border-t border-black text-[10px] text-gray-500 flex justify-between">
            <span>&copy; {new Date().getFullYear()} ABHINAV CHINNUSAMY</span>
            <span className="uppercase tracking-tighter">Minimalism by Design</span>
        </footer>
    );
};

export default Footer;
